const LANG_STORAGE_KEY = "mnogo-reels-language";

/** Синхронизация с language-context.tsx (открытие главного сайта с выбранным языком). */
export default function mnrLanguagePref() {
    document.querySelectorAll("[data-mnr-lang]").forEach((el) => {
        el.addEventListener("click", () => {
            const lang = el.getAttribute("data-mnr-lang");
            if (lang !== "ru" && lang !== "en") {
                return;
            }
            try {
                localStorage.setItem(LANG_STORAGE_KEY, lang);
            } catch {
                /* ignore */
            }
        });
    });

    document.addEventListener("click", (e) => {
        const t = e.target;
        if (!(t instanceof Node)) {
            return;
        }
        document.querySelectorAll("details.mnr-lang").forEach((details) => {
            if (details.open && !details.contains(t)) {
                details.removeAttribute("open");
            }
        });
    });
}
